module.exports = __webpack_public_path__ + "media/flags/nf-8e347812.svg";